import { render } from "./AccountApiKeys.vue?vue&type=template&id=3bdecf6c&scoped=true"
import script from "./AccountApiKeys.vue?vue&type=script&lang=js"
export * from "./AccountApiKeys.vue?vue&type=script&lang=js"

import "./AccountApiKeys.vue?vue&type=style&index=0&id=3bdecf6c&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bdecf6c"]])

export default __exports__